import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmIndoorTypeShape",
  "use": "svg-icon-cpmIndoorTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmIndoorTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1h8v14H0V1zm9 12h5V8H9V6h7v9H9v-2zm-3 0H2V3h4v10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol